export default [
  {
    level: '1',
    code: 'Sr',
    label: 'Sr',
    description: '(Senior)'
  },
  {
    level: '2',
    code: 'Jr',
    label: 'Jr',
    description: '(Junior)'
  },
  {
    level: '3',
    code: 'III',
    label: 'III',
    description: '(The Third)'
  },
  {
    level: '4',
    code: 'IV',
    label: 'IV',
    description: '(The Fourth)'
  },
  {
    level: '5',
    code: 'MD',
    label: 'MD',
    description: '(Doctor of Medicine)'
  }
]
